module.exports = __webpack_public_path__ + "static/media/kenai-logo.72757679.svg";